// Note: User info functions have been removed - user info is now managed via RTK Query
// See @features/user/store/hooks.ts for useUserInfo(), useUserPicture(), etc.

/**
 * Saves the current URL (pathname + search + hash) to localStorage
 * so that after login, users are redirected back to where they were going.
 *
 * This is used before redirecting to Auth0 login.
 */
export const saveReturnToUrl = () => {
  // Get the full path including pathname, search params, and hash
  const returnTo = window.location.pathname + window.location.search + window.location.hash;

  // Only save if it's not already the root or callback
  if (returnTo !== '/' && !returnTo.startsWith('/callback')) {
    localStorage.setItem('returnTo', returnTo);
  }
};

/**
 * Gets the saved returnTo URL from localStorage.
 */
export const getReturnToUrl = (): string | null => {
  return localStorage.getItem('returnTo');
};

/**
 * Clears the saved returnTo URL from localStorage.
 */
export const clearReturnToUrl = () => {
  localStorage.removeItem('returnTo');
};
